import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-136d46e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "is-open": _ctx.isOpen,
    onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle'))),
    width: "1280px"
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    body: _withCtx(() => [
      _createVNode(_component_Search, {
        id: "searchUser",
        "search-bar-text": "Pesquisar nome...",
        "width-input": "300px"
      })
    ]),
    _: 1
  }, 8, ["is-open"]))
}